import styles from './Contact.module.scss';
import map from '../../assets/webp/mapMeka.png';
import WspAdd from "../../components/WspAdd/WspAdd";
import { useSEO } from '../../hooks/useSEO';


function Contact () {
    useSEO({
        title: 'Contacto',
        description: 'Contáctenos en Ingeniería Meka Industrial, Puebla, México. Estamos disponibles vía WhatsApp, Facebook y Google Maps. Solicite información sobre nuestras Plantas Tratadoras de Aguas Residuales.',
        canonical: 'https://www.ingenieriameka.com/contact'
    });

    const mapLink = 'https://maps.app.goo.gl/RwSVG6ccPH7bqj9o6';

    return (
        <div className={styles.contact}>
            <div className={styles.contactContainer}>

                <h1>Estar cerca de ti es lo que nos sostiene</h1>
                <p>
                    Si tienes alguna pregunta o necesitas más información sobre nuestras Plantas 
                    Tratadoras de Aguas Residuales o consumibles, no dudes en contactarnos.
                    Estamos en Puebla, México.
                </p>

                <a href={mapLink} aria-label="Ver ubicación de Ingeniería Meka Industrial en Google Maps">
                    <img src={map} alt="Mapa de ubicación Ingeniería Meka Industrial en Puebla, México" />
                </a>
            </div>
            <WspAdd/>
        </div>
    )
}

export default Contact;	